var styleDataHash = "0a8d1cea";
const injectCss = () => {
  var css = `.hOWtE{--wds-side-panel-footer-padding-vertical:18px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var floating_desktop_layout_default = {
  "footer": "hOWtE"
};
export {
  floating_desktop_layout_default as default,
  injectCss
};
//# sourceMappingURL=floating-desktop-layout-scss.js.map
